import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import { __privateAdd, __privateGet, __privateSet, __privateWrapper } from "./chunk-PXG64RU4.js"; // src/queryClient.ts

import { functionalUpdate, hashKey, hashQueryKeyByOptions, noop, partialMatchKey, resolveStaleTime, skipToken } from "./utils.js";
import { QueryCache } from "./queryCache.js";
import { MutationCache } from "./mutationCache.js";
import { focusManager } from "./focusManager.js";
import { onlineManager } from "./onlineManager.js";
import { notifyManager } from "./notifyManager.js";
import { infiniteQueryBehavior } from "./infiniteQueryBehavior.js";

var _queryCache, _mutationCache, _defaultOptions, _queryDefaults, _mutationDefaults, _mountCount, _unsubscribeFocus, _unsubscribeOnline;

var QueryClient = /*#__PURE__*/function () {
  function QueryClient() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, QueryClient);

    __privateAdd(this, _queryCache);

    __privateAdd(this, _mutationCache);

    __privateAdd(this, _defaultOptions);

    __privateAdd(this, _queryDefaults);

    __privateAdd(this, _mutationDefaults);

    __privateAdd(this, _mountCount);

    __privateAdd(this, _unsubscribeFocus);

    __privateAdd(this, _unsubscribeOnline);

    __privateSet(this, _queryCache, config.queryCache || new QueryCache());

    __privateSet(this, _mutationCache, config.mutationCache || new MutationCache());

    __privateSet(this, _defaultOptions, config.defaultOptions || {});

    __privateSet(this, _queryDefaults, /* @__PURE__ */new Map());

    __privateSet(this, _mutationDefaults, /* @__PURE__ */new Map());

    __privateSet(this, _mountCount, 0);
  }

  return _createClass(QueryClient, [{
    key: "mount",
    value: function mount() {
      var _this = this;

      __privateWrapper(this, _mountCount)._++;
      if (__privateGet(this, _mountCount) !== 1) return;

      __privateSet(this, _unsubscribeFocus, focusManager.subscribe( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(focused) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!focused) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return _this.resumePausedMutations();

              case 3:
                __privateGet(_this, _queryCache).onFocus();

              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()));

      __privateSet(this, _unsubscribeOnline, onlineManager.subscribe( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(online) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!online) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 3;
                return _this.resumePausedMutations();

              case 3:
                __privateGet(_this, _queryCache).onOnline();

              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()));
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _a, _b;

      __privateWrapper(this, _mountCount)._--;
      if (__privateGet(this, _mountCount) !== 0) return;
      (_a = __privateGet(this, _unsubscribeFocus)) == null ? void 0 : _a.call(this);

      __privateSet(this, _unsubscribeFocus, void 0);

      (_b = __privateGet(this, _unsubscribeOnline)) == null ? void 0 : _b.call(this);

      __privateSet(this, _unsubscribeOnline, void 0);
    }
  }, {
    key: "isFetching",
    value: function isFetching(filters) {
      return __privateGet(this, _queryCache).findAll(_objectSpread(_objectSpread({}, filters), {}, {
        fetchStatus: "fetching"
      })).length;
    }
  }, {
    key: "isMutating",
    value: function isMutating(filters) {
      return __privateGet(this, _mutationCache).findAll(_objectSpread(_objectSpread({}, filters), {}, {
        status: "pending"
      })).length;
    }
    /**
     * Imperative (non-reactive) way to retrieve data for a QueryKey.
     * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
     *
     * Hint: Do not use this function inside a component, because it won't receive updates.
     * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
     */

  }, {
    key: "getQueryData",
    value: function getQueryData(queryKey) {
      var _a;

      var options = this.defaultQueryOptions({
        queryKey: queryKey
      });
      return (_a = __privateGet(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
  }, {
    key: "ensureQueryData",
    value: function ensureQueryData(options) {
      var defaultedOptions = this.defaultQueryOptions(options);

      var query = __privateGet(this, _queryCache).build(this, defaultedOptions);

      var cachedData = query.state.data;

      if (cachedData === void 0) {
        return this.fetchQuery(options);
      }

      if (options.revalidateIfStale && query.isStaleByTime(resolveStaleTime(defaultedOptions.staleTime, query))) {
        void this.prefetchQuery(defaultedOptions);
      }

      return Promise.resolve(cachedData);
    }
  }, {
    key: "getQueriesData",
    value: function getQueriesData(filters) {
      return __privateGet(this, _queryCache).findAll(filters).map(function (_ref3) {
        var queryKey = _ref3.queryKey,
            state = _ref3.state;
        var data = state.data;
        return [queryKey, data];
      });
    }
  }, {
    key: "setQueryData",
    value: function setQueryData(queryKey, updater, options) {
      var defaultedOptions = this.defaultQueryOptions({
        queryKey: queryKey
      });

      var query = __privateGet(this, _queryCache).get(defaultedOptions.queryHash);

      var prevData = query == null ? void 0 : query.state.data;
      var data = functionalUpdate(updater, prevData);

      if (data === void 0) {
        return void 0;
      }

      return __privateGet(this, _queryCache).build(this, defaultedOptions).setData(data, _objectSpread(_objectSpread({}, options), {}, {
        manual: true
      }));
    }
  }, {
    key: "setQueriesData",
    value: function setQueriesData(filters, updater, options) {
      var _this2 = this;

      return notifyManager.batch(function () {
        return __privateGet(_this2, _queryCache).findAll(filters).map(function (_ref4) {
          var queryKey = _ref4.queryKey;
          return [queryKey, _this2.setQueryData(queryKey, updater, options)];
        });
      });
    }
  }, {
    key: "getQueryState",
    value: function getQueryState(queryKey) {
      var _a;

      var options = this.defaultQueryOptions({
        queryKey: queryKey
      });
      return (_a = __privateGet(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
  }, {
    key: "removeQueries",
    value: function removeQueries(filters) {
      var queryCache = __privateGet(this, _queryCache);

      notifyManager.batch(function () {
        queryCache.findAll(filters).forEach(function (query) {
          queryCache.remove(query);
        });
      });
    }
  }, {
    key: "resetQueries",
    value: function resetQueries(filters, options) {
      var _this3 = this;

      var queryCache = __privateGet(this, _queryCache);

      return notifyManager.batch(function () {
        queryCache.findAll(filters).forEach(function (query) {
          query.reset();
        });
        return _this3.refetchQueries(_objectSpread({
          type: "active"
        }, filters), options);
      });
    }
  }, {
    key: "cancelQueries",
    value: function cancelQueries(filters) {
      var _this4 = this;

      var cancelOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var defaultedCancelOptions = _objectSpread({
        revert: true
      }, cancelOptions);

      var promises = notifyManager.batch(function () {
        return __privateGet(_this4, _queryCache).findAll(filters).map(function (query) {
          return query.cancel(defaultedCancelOptions);
        });
      });
      return Promise.all(promises).then(noop).catch(noop);
    }
  }, {
    key: "invalidateQueries",
    value: function invalidateQueries(filters) {
      var _this5 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return notifyManager.batch(function () {
        var _ref5, _ref6;

        __privateGet(_this5, _queryCache).findAll(filters).forEach(function (query) {
          query.invalidate();
        });

        if ((filters == null ? void 0 : filters.refetchType) === "none") {
          return Promise.resolve();
        }

        return _this5.refetchQueries(_objectSpread(_objectSpread({}, filters), {}, {
          type: (_ref5 = (_ref6 = filters == null ? void 0 : filters.refetchType) !== null && _ref6 !== void 0 ? _ref6 : filters == null ? void 0 : filters.type) !== null && _ref5 !== void 0 ? _ref5 : "active"
        }), options);
      });
    }
  }, {
    key: "refetchQueries",
    value: function refetchQueries(filters) {
      var _options$cancelRefetc,
          _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var fetchOptions = _objectSpread(_objectSpread({}, options), {}, {
        cancelRefetch: (_options$cancelRefetc = options.cancelRefetch) !== null && _options$cancelRefetc !== void 0 ? _options$cancelRefetc : true
      });

      var promises = notifyManager.batch(function () {
        return __privateGet(_this6, _queryCache).findAll(filters).filter(function (query) {
          return !query.isDisabled() && !query.isStatic();
        }).map(function (query) {
          var promise = query.fetch(void 0, fetchOptions);

          if (!fetchOptions.throwOnError) {
            promise = promise.catch(noop);
          }

          return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
        });
      });
      return Promise.all(promises).then(noop);
    }
  }, {
    key: "fetchQuery",
    value: function fetchQuery(options) {
      var defaultedOptions = this.defaultQueryOptions(options);

      if (defaultedOptions.retry === void 0) {
        defaultedOptions.retry = false;
      }

      var query = __privateGet(this, _queryCache).build(this, defaultedOptions);

      return query.isStaleByTime(resolveStaleTime(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
  }, {
    key: "prefetchQuery",
    value: function prefetchQuery(options) {
      return this.fetchQuery(options).then(noop).catch(noop);
    }
  }, {
    key: "fetchInfiniteQuery",
    value: function fetchInfiniteQuery(options) {
      options.behavior = infiniteQueryBehavior(options.pages);
      return this.fetchQuery(options);
    }
  }, {
    key: "prefetchInfiniteQuery",
    value: function prefetchInfiniteQuery(options) {
      return this.fetchInfiniteQuery(options).then(noop).catch(noop);
    }
  }, {
    key: "ensureInfiniteQueryData",
    value: function ensureInfiniteQueryData(options) {
      options.behavior = infiniteQueryBehavior(options.pages);
      return this.ensureQueryData(options);
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      if (onlineManager.isOnline()) {
        return __privateGet(this, _mutationCache).resumePausedMutations();
      }

      return Promise.resolve();
    }
  }, {
    key: "getQueryCache",
    value: function getQueryCache() {
      return __privateGet(this, _queryCache);
    }
  }, {
    key: "getMutationCache",
    value: function getMutationCache() {
      return __privateGet(this, _mutationCache);
    }
  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return __privateGet(this, _defaultOptions);
    }
  }, {
    key: "setDefaultOptions",
    value: function setDefaultOptions(options) {
      __privateSet(this, _defaultOptions, options);
    }
  }, {
    key: "setQueryDefaults",
    value: function setQueryDefaults(queryKey, options) {
      __privateGet(this, _queryDefaults).set(hashKey(queryKey), {
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  }, {
    key: "getQueryDefaults",
    value: function getQueryDefaults(queryKey) {
      var defaults = _toConsumableArray(__privateGet(this, _queryDefaults).values());

      var result = {};
      defaults.forEach(function (queryDefault) {
        if (partialMatchKey(queryKey, queryDefault.queryKey)) {
          Object.assign(result, queryDefault.defaultOptions);
        }
      });
      return result;
    }
  }, {
    key: "setMutationDefaults",
    value: function setMutationDefaults(mutationKey, options) {
      __privateGet(this, _mutationDefaults).set(hashKey(mutationKey), {
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  }, {
    key: "getMutationDefaults",
    value: function getMutationDefaults(mutationKey) {
      var defaults = _toConsumableArray(__privateGet(this, _mutationDefaults).values());

      var result = {};
      defaults.forEach(function (queryDefault) {
        if (partialMatchKey(mutationKey, queryDefault.mutationKey)) {
          Object.assign(result, queryDefault.defaultOptions);
        }
      });
      return result;
    }
  }, {
    key: "defaultQueryOptions",
    value: function defaultQueryOptions(options) {
      if (options._defaulted) {
        return options;
      }

      var defaultedOptions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __privateGet(this, _defaultOptions).queries), this.getQueryDefaults(options.queryKey)), options), {}, {
        _defaulted: true
      });

      if (!defaultedOptions.queryHash) {
        defaultedOptions.queryHash = hashQueryKeyByOptions(defaultedOptions.queryKey, defaultedOptions);
      }

      if (defaultedOptions.refetchOnReconnect === void 0) {
        defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
      }

      if (defaultedOptions.throwOnError === void 0) {
        defaultedOptions.throwOnError = !!defaultedOptions.suspense;
      }

      if (!defaultedOptions.networkMode && defaultedOptions.persister) {
        defaultedOptions.networkMode = "offlineFirst";
      }

      if (defaultedOptions.queryFn === skipToken) {
        defaultedOptions.enabled = false;
      }

      return defaultedOptions;
    }
  }, {
    key: "defaultMutationOptions",
    value: function defaultMutationOptions(options) {
      if (options == null ? void 0 : options._defaulted) {
        return options;
      }

      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __privateGet(this, _defaultOptions).mutations), (options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey)), options), {}, {
        _defaulted: true
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      __privateGet(this, _queryCache).clear();

      __privateGet(this, _mutationCache).clear();
    }
  }]);
}();

_queryCache = new WeakMap();
_mutationCache = new WeakMap();
_defaultOptions = new WeakMap();
_queryDefaults = new WeakMap();
_mutationDefaults = new WeakMap();
_mountCount = new WeakMap();
_unsubscribeFocus = new WeakMap();
_unsubscribeOnline = new WeakMap();
export { QueryClient };